import { render, staticRenderFns } from "./ChooseLanguage.vue?vue&type=template&id=290060ed&scoped=true"
import script from "./ChooseLanguage.vue?vue&type=script&lang=js"
export * from "./ChooseLanguage.vue?vue&type=script&lang=js"
import style0 from "./ChooseLanguage.vue?vue&type=style&index=0&id=290060ed&prod&lang=scss&scoped=true"
import style1 from "./ChooseLanguage.vue?vue&type=style&index=1&id=290060ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290060ed",
  null
  
)

export default component.exports